module.exports = __webpack_public_path__ + "01_glasses_blue.49f92a99.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/mama/layer4/01_glasses_blue.png
// module id = /l+u
// module chunks = 0